import { z } from "zod";
import { type PagesConfig } from "~/domains/pageSchemas";
import { exclusiveCheckboxesSchema } from "~/services/validation/checkedCheckbox";
import { YesNoAnswer } from "~/services/validation/YesNoAnswer";

export const kontopfaendungWegweiserPages = {
  start: {
    stepId: "/start",
  },
  kontopfaendung: {
    stepId: "/kontopfaendung",
    pageSchema: {
      hasKontopfaendung: YesNoAnswer,
    },
  },
  ergebnisKeineKontopfaendung: {
    stepId: "/ergebnis/keine-kontopfaendung",
  },
  pKonto: {
    stepId: "/p-konto",
    pageSchema: {
      hasPKonto: z.enum(["no", "yes", "nichtAktiv", "nichtEingerichtet"]),
    },
  },
  zwischenseiteUnterhalt: {
    stepId: "/zwischenseite-unterhalt",
  },
  pKontoProbleme: {
    stepId: "/p-konto-probleme",
  },
  kinder: {
    stepId: "/kinder",
    pageSchema: { hasKinder: YesNoAnswer },
  },
  kinderWohnenZusammen: {
    stepId: "/kinder-wohnen-zusammen",
    pageSchema: {
      kinderWohnenZusammen: z.enum(["no", "yes", "teilweise"]),
    },
  },
  kinderUnterhalt: {
    stepId: "/kinder-unterhalt",
    pageSchema: { kinderUnterhalt: YesNoAnswer },
  },
  partner: {
    stepId: "/partner",
    pageSchema: {
      verheiratet: z.enum(["no", "yes", "geschieden", "verwitwet"]),
    },
  },
  partnerWohnenZusammen: {
    stepId: "/partner-wohnen-zusammen",
    pageSchema: {
      partnerWohnenZusammen: YesNoAnswer,
    },
  },
  partnerUnterhalt: {
    stepId: "/partner-unterhalt",
    pageSchema: { partnerUnterhalt: YesNoAnswer },
  },
  zwischenseiteEinkuenfte: {
    stepId: "/zwischenseite-einkuenfte",
  },
  arbeit: {
    stepId: "/arbeit",
    pageSchema: { hasArbeit: YesNoAnswer },
  },
  arbeitArt: {
    stepId: "/arbeit-art",
    pageSchema: {
      arbeitArt: z.enum(["angestellt", "selbstaendig", "beides"]),
    },
  },
  nachzahlungArbeitgeber: {
    stepId: "/nachzahlung-arbeitgeber",
    pageSchema: { nachzahlungArbeitgeber: YesNoAnswer },
  },
  hoeheNachzahlungArbeitgeber: {
    stepId: "/hoehe-nachzahlung-arbeitgeber",
    pageSchema: { arbeitgeberNachzahlungGreaterThan500: YesNoAnswer },
  },
  einmalzahlungArbeitgeber: {
    stepId: "/einmalzahlung-arbeitgeber",
    pageSchema: {
      zahlungArbeitgeber: exclusiveCheckboxesSchema([
        "urlaubsgeld",
        "weihnachtsgeld",
        "ueberstundenBezahlt",
        "abfindung",
        "anderes",
        "none",
      ]),
    },
  },
  sozialleistungen: {
    stepId: "/sozialleistungen",
    pageSchema: {
      hasSozialleistungen: z.enum([
        "buergergeld",
        "grundsicherungSozialhilfe",
        "asylbewerberleistungen",
        "no",
      ]),
    },
  },
  sozialleistungNachzahlung: {
    stepId: "/sozialleistung-nachzahlung",
    pageSchema: { hasSozialleistungNachzahlung: YesNoAnswer },
  },
  sozialleistungenEinmalzahlung: {
    stepId: "/sozialleistungen-einmalzahlung",
    pageSchema: {
      hasSozialleistungenEinmalzahlung: YesNoAnswer,
    },
  },
  pflegegeld: {
    stepId: "/pflegegeld",
    pageSchema: {
      hasPflegegeld: YesNoAnswer,
    },
  },
  wohngeld: {
    stepId: "/wohngeld",
    pageSchema: {
      hasWohngeld: YesNoAnswer,
    },
  },
  wohngeldEmpfaenger: {
    stepId: "/wohngeld-empfaenger",
    pageSchema: {
      wohngeld: z.enum(["selbst", "fremd"]),
    },
  },
  wohngeldNachzahlung: {
    stepId: "/wohngeld-nachzahlung",
    pageSchema: { hasWohngeldNachzahlung: YesNoAnswer },
  },
  kindergeld: {
    stepId: "/kindergeld",
    pageSchema: {
      hasKindergeld: YesNoAnswer,
    },
  },
  kindergeldNachzahlung: {
    stepId: "/kindergeld-nachzahlung",
    pageSchema: {
      hasKindergeldNachzahlung: YesNoAnswer,
    },
  },
  rente: {
    stepId: "/rente",
    pageSchema: {
      hasRente: YesNoAnswer,
    },
  },
  ergebnisNaechsteSchritte: {
    stepId: "/ergebnis/naechste-schritte",
  },
} as const satisfies PagesConfig;
